export default __webpack_public_path__ + "static/media/4.03fa6b65.png";